export default __webpack_public_path__ + "static/media/c10.1ff9a074.jpg";